var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{attrs:{"src":"http://sky.cnzhonglunnet.com/general","width":"100%","height":"1024","frameborder":"0"}})])}]

export { render, staticRenderFns }